module.exports = __webpack_public_path__ + "img/11_Kombipaket-4.af8f7019.jpg";